import { render, staticRenderFns } from "./PricingMonthlyFeature.vue?vue&type=template&id=4f2cf812"
import script from "./PricingMonthlyFeature.vue?vue&type=script&lang=js"
export * from "./PricingMonthlyFeature.vue?vue&type=script&lang=js"
import style0 from "./PricingMonthlyFeature.vue?vue&type=style&index=0&id=4f2cf812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports